<template>
	<div class="my">
		<img src="../../assets/logotable.png" style="
        position: fixed;
        top: 0.8rem;
        z-index: 9;
        height: 1.5rem;
        right: 50vw;
      " />
		<nav-bar title="经费审批" left-text="返回" left-arrow @click-left="onClickLeft" class="my-nav">
		</nav-bar>
		<div style="margin-top: 2.9rem"></div>

		<cell-group title="经费审批">
			<collapse v-model="activeNames">
				<div v-for="(v, i) in list" :key="i">
					<collapse-item :title="v.pro.activity.activityName" :name="i"
						:label="'提交时间：' + ptime(v.pro.oddNumber)" v-if="v.pro">
						<cell v-for="(val, index) in v.pro.budgets" :key="index" :title="val.details"
							:value="val.rental + '元'" />
						<ant-row v-if="v.pro.approveStatus == 1" type="flex" justify="center">
							<ant-button type="info" @click="modify(v, true)" size="small" class="btn">
								同意
							</ant-button>
							<ant-button @click="modify(v)" size="small" class="btn">
								不同意
							</ant-button>
						</ant-row>
						<ant-row v-else>
							{{ v.pro.approveStatus == 2 ? "通过" : "不通过" }} 审批意见：{{
                v.investigatecontent
              }}
						</ant-row>
					</collapse-item>
				</div>
			</collapse>
			<!-- 分页-->
			<pagination v-model="page" :total-items="total" mode="simple" @change="init()" v-if="list.length" />
			<empty v-else description="暂无数据" />
		</cell-group>
		<!-- 审批历史-->
		<cell-group title="审批历史">
			<collapse v-model="activeNamesB">
				<div v-for="(v, i) in listB" :key="i">
					<collapse-item :title="v.pro.activity.activityName" :name="i"
						:label="'提交时间：' + ptime(v.pro.oddNumber)" v-if="v.pro">
						<cell v-for="(val, index) in v.pro.budgets" :key="index" :title="val.details"
							:value="val.rental + '元'" />
					</collapse-item>
				</div>
			</collapse>
			<!-- 分页-->
			<pagination v-model="pageB" :total-items="totalB" mode="simple" @change="init()" v-if="listB.length" />
			<empty v-else description="暂无数据" />
		</cell-group>
		<!-- 编辑-->
		<popup v-model="show" round position="bottom" :style="{ height: '50%' }">
			<ant-form validate-first @submit="onSubmit">
				<div style="margin: 1rem">
					<div style="
		    display: flex;
		    align-content: center;
		    justify-content: space-between;
		  " v-show="isshowupapproval && this.approveStatus == '1'">
						<div v-show="!btn('three-group') && !btn('three_approval') ">
							<span style="color: #646566；padding:10px 16px"> 是否上级审批：</span>
							<van-switch size="18px" v-model="copySuperior" @change="switchChane" />
						</div>
						<div v-show="showSelect" @click="endSelect">确定</div>
					</div>

					<div style="margin-top: 20px" v-show="!showSelect">
						<ant-field label="上级审批：" v-model="userName" v-if="copySuperior" />
						<ant-field label="审批意见：" v-model="form.vehicleName" required rows="2" autosize type="textarea"
							maxlength="50" show-word-limit :rules="[{ required: true, message: '请填写审批意见' }]"
							placeholder="请输入审批意见" />
						<div style="margin: 16px">
							<ant-button round block type="danger" native-type="submit" :loading="loading">
								提交
							</ant-button>
						</div>
					</div>
					<div v-show="showSelect">
						<picker :columns="approvalpersons" @change="onupChange" value-key="userName" />
					</div>
				</div>
			</ant-form>
		</popup>
		<!-- <popup v-model="showa" round position="bottom" :style="{ height: '40%' }">
      <div style="margin: 1rem">
        <ant-form validate-first @submit="onSubmita">
          <ant-field
            label="审批意见："
            v-model="form.vehicleName"
            required
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            show-word-limit
            :rules="[{ required: true, message: '请填写审批意见' }]"
            placeholder="请输入审批意见"
          />
          <div style="margin: 16px">
            <ant-button round block type="danger" native-type="submit">
              提交
            </ant-button>
          </div>
        </ant-form>
      </div>
    </popup> -->
	</div>
</template>

<script>
	import {
		Cell,
		CellGroup,
		NavBar,
		Divider,
		Button,
		Form,
		Field,
		DatetimePicker,
		Picker,
		Popup,
		Toast,
		Collapse,
		CollapseItem,
		Col,
		Row,
		Pagination,
		Dialog,
		Icon,
		SwipeCell,
		Empty,
	} from "vant";
	import service from "../../api/service";
	import moment from "moment";
	//经费审批
	export default {
		name: "fundActivities",
		components: {
			Cell,
			CellGroup,
			NavBar,
			Divider,
			AntButton: Button,
			AntForm: Form,
			AntField: Field,
			DatetimePicker,
			Popup,
			Picker,
			Collapse,
			CollapseItem,
			AntCol: Col,
			AntRow: Row,
			Pagination,
			Dialog,
			Icon,
			SwipeCell,
			Empty,
		},
		data() {
			return {
				approveStatus: "",
				loading: false,
				approvalpersons: [],
				isshowupapproval:true,
				userName: "-",
				id: "-",
				activityName: "",
				activeNames: [],
				activeNamesB: [],
				showSelect: false,
				upindex: 0,
				list: [],
				listB: [],
				page: 1,
				pageB: 1,
				total: 0,
				totalB: 0,
				show: false,
				showa: false,
				checked: false,
				copySuperior: false,
				form: {
					vehicleName: "",
				},
			};
		},
		mounted() {
			this.id = this.$route.query.id;
			this.activityName = this.$route.query.activityName;
			this.init();
		},
		methods: {
			switchChane(v) {
				this.copySuperior = v;
				this.showSelect = v;
				if (!v) {
					this.nextApprovalNodeApproverId = {};
				}
			},
			init() {
				let deptId = sessionStorage.getItem("deptId");
				if(deptId.indexOf(",") < 0){
					service
						.get("/system/app-user/queryBudgetApproverUserByUserId", {
						})
						.then((res) => {
							if (res.status === 200) {
								this.approvalpersons = res.data;
								let approvalpersonuserid = this.approvalpersons.map(item => {
									return item.id;
								}).join(",");
								if(approvalpersonuserid.indexOf(sessionStorage.getItem("id")) >= 0){
									this.isshowupapproval = false;
								}
							}
						});
					
				}else{
					service
						.get("/api/activity/queryapprover", {
							deptid: sessionStorage.getItem("deptId"),
						})
						.then((res) => {
							if (res.status === 200) {
								this.approvalpersons = res.data;
								let approvalpersonuserid = this.approvalpersons.map(item => {
									return item.id;
								}).join(",");
								if(approvalpersonuserid.indexOf(sessionStorage.getItem("id")) >= 0){
									this.isshowupapproval = false;
								}
							}
						});
					
				}

				service
					.get("/api/activity-creation-approval/querybudgetdetails", {
						deptId: sessionStorage.getItem("deptId"),
						page: this.page,
						userId: sessionStorage.getItem("id"),
					})
					.then((res) => {
						if (res.status === 200) {
							// this.list = res.data;
							this.list = res.data.filter(function(s) {
								return s.pro && s.pro.activity;
							});

							this.total = res.total;
						}
					});
				service
					.get("/api/activity-creation-approval/historyOfFundingApproval", {
						deptId: sessionStorage.getItem("deptId"),
						page: this.page,
						userId: sessionStorage.getItem("id"),
					})
					.then((res) => {
						if (res.status === 200) {
							this.listB = res.data.filter(function(s) {
								return s.pro && s.pro.activity;
							});
							this.totalB = res.total;
						}
					});
			},
			onClickLeft() {
				this.$router.push({
					path: "/personalCenter"
				});
			},
			clickRightIcon(i) {
				if (i === this.forms.length - 1) {
					this.forms.push({
						activityId: this.id,
						deptBunch: sessionStorage.getItem("deptId"),
						details: "",
						rental: 0,
					});
				} else {
					this.forms.splice(i, 1);
				}
			},
			ptime(v) {
				let d = Number(v);
				return v ? moment(d).format("YYYY-MM-DD HH:mm:ss") : "-";
			},
			modify(v, b) {
				this.row = v;
				this.show = true;
				this.approveStatus = b ? "1" : "2";
			},

			onupChange(picker, value, index) {
				this.upindex = index;
			},

			endSelect() {
				this.nextApprovalNodeApproverId = this.approvalpersons[this.upindex];
				if (this.nextApprovalNodeApproverId) {
					this.userName = this.nextApprovalNodeApproverId.userName;
					this.showSelect = false;
				}
			},

			//提交同意
			onSubmit() {
				let form = {
					proId: this.row.pro.proId,
					approveStatus: this.approveStatus,
					aprvoceOpinion: this.form.vehicleName,
					aproveUserId: sessionStorage.getItem("id"),
					flowId: this.row.pro.approveFlowId,
					action: this.copySuperior ? 1 : 0,
				};
				if (this.copySuperior)
					form.nextApprovalNodeApproverId = this.nextApprovalNodeApproverId.id;
				this.loading = true;
				service
					.post("/api/activity-creation-approval/passbudget", form)
					.then((res) => {
						this.loading = false;
						if (res.status === 200) {
							Toast.success(res.message);
							this.checked = false;
							this.copySuperior = false;
							this.show = false;
							this.init();
						} else {
							Toast.fail(res.message);
						}
					});
			},
			//提交不同意
			onSubmita() {
				let form = {
					...this.form
				};
				form.deptBunch = sessionStorage.getItem("deptId");
				form.investigatePeopleId = sessionStorage.getItem("id");
				form.investigateResult = 0;
				form.ininvestigateId = this.row.activityId;
				form.investigateContent = form.vehicleName;
				form.version = this.row.version;
				if (this.copySuperior) form.superiorType = 1;
				// if (this.copySuperior)
				//   form.nextApprovalNodeApproverId = this.nextApprovalNodeApproverId.id;
				service
					.post("/api/activity-creation-approval/passbudget", form)
					.then((res) => {
						if (res.status === 200) {
							Toast.success(res.message);
							this.checked = false;
							this.copySuperior = false;
							this.show = false;
							this.init();
						} else {
							Toast.fail(res.message);
						}
					});
			},
		},
	};
</script>

<style scoped>
	.my {
		background-color: #f7f8fa;
		min-height: 100vh;
	}

	.btn {
		margin: 1rem;
		width: 30%;
	}
</style>
